module.exports = __webpack_public_path__ + "img/praiseGrayBtn-big.c05ba465.png";